const buildApprovalStatuses = (placeholderType) => [
  {
    id: 'status-draft',
    title: 'Draft',
    icon: 'approval',
    color: 'n5',
    payload: {
      type_key: 'statuses',
      object: {
        status: 'draft',
      },
    },
  },
  {
    id: 'status-pending',
    title: 'For Approval',
    icon: 'approval',
    color: 'orange',
    payload: {
      type_key: 'statuses',
      object: {
        status: 'pending',
      },
    },
  },
  {
    id: 'status-denied',
    title: 'Needs Revision',
    icon: 'approval',
    color: 'red',
    payload: {
      type_key: 'statuses',
      object: {
        status: 'denied',
      },
    },
  },
  {
    id: 'status-approved',
    title: 'Approved',
    icon: 'approval',
    color: 'green',
    payload: {
      type_key: 'statuses',
      object: {
        status: 'approved',
      },
    },
  },
  {
    id: 'status-idea',
    title: `${placeholderType} Placeholder`,
    icon: 'approval',
    color: 'n8',
    payload: {
      type_key: 'statuses',
      object: {
        status: 'idea',
      },
    },
  },
]

const buildApprovalStatusFilters = (placeholderType = 'Moment') => {
  const options = buildApprovalStatuses(placeholderType)
  return {
    id: 'approval-status',
    title: 'Approval Status',
    icon: 'approval',
    childOptions: options,
  }
}

export default buildApprovalStatusFilters
